import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { ShoppingBag } from "lucide-react";
import { Logo } from "./Logo";
import { useCart } from "@/lib/cart";
import { scrollToId } from "@/lib/lenis";

const LINKS = [["shop", "Shop"], ["story", "Our story"], ["postage", "Postage"], ["faq", "FAQ"]];

export const Nav = () => {
  const { count, setOpen } = useCart();
  const [solid, setSolid] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const on = () => {
      setSolid(window.scrollY > window.innerHeight * 0.75);
      setScrolled(window.scrollY > 40);
    };
    on();
    window.addEventListener("scroll", on, { passive: true });
    return () => window.removeEventListener("scroll", on);
  }, []);

  return (
    <motion.header
      initial={{ y: -40, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.8, delay: 0.9, ease: [0.16, 1, 0.3, 1] }}
      className={`fixed inset-x-0 top-0 z-50 transition-colors duration-500 ${solid ? "bg-[#F5F0E8]/85 backdrop-blur-xl border-b border-[#112E23]/10" : scrolled ? "bg-[#0B1D16]/80 backdrop-blur-xl" : "bg-transparent"}`}
    >
      <div className="mx-auto flex h-[72px] max-w-[1400px] items-center justify-between px-5 sm:px-8">
        <button data-testid="nav-logo-button" onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}>
          <Logo light={!solid} />
        </button>
        <nav className="hidden items-center gap-9 md:flex">
          {LINKS.map(([id, label]) => (
            <button
              key={id}
              data-testid={`nav-${id}-link`}
              onClick={() => scrollToId(id)}
              className={`nav-link text-sm font-semibold ${solid ? "text-[#112E23]" : "text-[#F5F0E8]"}`}
            >
              {label}
            </button>
          ))}
        </nav>
        <div className="flex items-center gap-2">
          <button
            data-testid="nav-shop-mobile-button"
            onClick={() => scrollToId("shop")}
            className={`rounded-full px-4 py-2 text-sm font-semibold md:hidden ${solid ? "text-[#112E23]" : "text-[#F5F0E8]"}`}
          >
            Shop
          </button>
          <button
            data-testid="nav-cart-trigger-button"
            onClick={() => setOpen(true)}
            className="group relative flex items-center gap-2 rounded-full bg-[#D99B26] px-4 py-2.5 text-sm font-bold text-[#0F1412] transition-transform duration-300 hover:-translate-y-0.5"
          >
            <ShoppingBag className="h-4 w-4 transition-transform duration-300 group-hover:rotate-[-8deg]" />
            <span className="hidden sm:inline">Cart</span>
            <span data-testid="nav-cart-count" className="grid h-5 min-w-5 place-items-center rounded-full bg-[#0F1412] px-1 font-mono text-[11px] text-[#F5F0E8]">
              {count}
            </span>
          </button>
        </div>
      </div>
    </motion.header>
  );
};
